<template>
  <div
    ref="contentModal"
    aria-hidden="true"
    aria-labelledby="messengerMessageModal"
    class="modal show fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content position-relative">
        <div class="modal-header">
          <h5 class="modal-title textStyle">
            {{ $t("header.notification.list") }}
          </h5>
          <button
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            data-dismiss="modal"
            type="button"
          ></button>
        </div>
        <div class="modal-body">
          <!-- ST143-TI-18922 : la modale est montée en permanence dans App.vue ; rendre la liste modale fermée
               insérait tout l'historique de l'utilisateur (des milliers de nœuds) à chaque chargement de page. -->
          <ul v-if="listOpened" ref="messageList" class="message-list">
            <NotificationComponent
              :message="message"
              :modal="true"
              v-for="(message, index) in list"
              :key="message.id"
              :separator="!!index"
            />
            <li role="presentation" v-if="!list || !Object.keys(list).length">
              <div class="dropdown-item">
                <div class="media file-upload">
                  <div class="media-body">
                    <div class="data-info">
                      <h6>
                        {{ $t("header.notification.empty") }}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="listOpened && listHasMore" class="text-center mt-3">
            <ButtonComponent
              :text="$t('header.notification.load_more')"
              className="outline-primary"
              :disabled="loading"
              @buttonClick="loadMore"
            />
          </div>
        </div>
        <BlockLoader :loading="loading" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useNotificationStore } from "@/store/notifications/notification";
import NotificationComponent from "@/components/notifications/NotificationComponent.vue";
import { messengerMessageManager } from "@/services/messenger-message/messenger-message-manager";
import BlockLoader from "@/components/blocks/BlockLoader.vue";
import { modalMixin } from "@/mixins/modalMixin";
import ButtonComponent from "@/components/utils/buttons/ButtonComponent.vue";

export default {
  name: "NotificationListModalComponent",
  components: { BlockLoader, ButtonComponent, NotificationComponent },
  mixins: [modalMixin],
  emits: ["hidden"],
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState(useNotificationStore, {
      listOpened: (store) => store.listOpened,
      list: (store) => store.list,
      listHasMore: (store) => store.listHasMore,
    }),
  },
  watch: {
    listOpened() {
      if (this.listOpened) {
        this.refreshList();
        this.showModal();
      } else {
        this.hideModal();
      }
    },
  },
  methods: {
    onModalHidden() {
      modalMixin.methods.onModalHidden.call(this);
      this.setListOpened(false);
    },

    async refreshList() {
      this.loading = true;
      try {
        await messengerMessageManager.loadListPage();
      } finally {
        this.loading = false;
      }
    },

    async loadMore() {
      const previousCount = this.list.length;
      this.loading = true;
      try {
        await messengerMessageManager.loadListPage(true);
      } finally {
        this.loading = false;
      }
      await this.$nextTick();
      const items = this.$refs.messageList?.querySelectorAll("button.dropdown-item") ?? [];
      (items[previousCount] ?? items[items.length - 1])?.focus();
    },

    ...mapActions(useNotificationStore, { setListOpened: "setListOpened" }),
  },
};
</script>

<style lang="scss" scoped></style>
